import { configureStore } from "@reduxjs/toolkit";
import headerReducer from "./headerSlice";
import overlayReducer from "./overlaySlice";

export function makeStore() {
  return configureStore({
    reducer: { header: headerReducer, overlay: overlayReducer },
  });
}

export type AppStore = ReturnType<typeof makeStore>;

export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
